// apps/frontend/src/lib/pipeline-preview/utils/schema.ts

/**
 * Infer schema from data
 */
export function inferSchema(data: unknown[]): { columns: any[] } {
  if (data.length === 0) {
    return { columns: [] };
  }

  const firstRow = data[0] as Record<string, unknown>;
  const columns = Object.keys(firstRow).map(key => ({
    name: key,
    type: inferType(firstRow[key]),
    nullable: true,
  }));

  return { columns };
}

/**
 * Infer data type from value
 */
export function inferType(value: unknown): string {
  if (value === null || value === undefined) return 'unknown';
  if (typeof value === 'number') return 'number';
  if (typeof value === 'boolean') return 'boolean';
  if (typeof value === 'string') {
    if (/^\d{4}-\d{2}-\d{2}/.test(value)) return 'date';
    return 'string';
  }
  if (typeof value === 'object') return 'json';
  return 'unknown';
}
